export const loginModalTitle = {
  fontFamily: "var(--font-arsenal)",
  fontWeight: 400,
  fontSize: "2.25rem",
  marginBottom: { xs: "0.75rem", md: "1.25rem" },
  textAlign: "center",
};

export const loginModalSubtitle = {
  fontSize: "1rem",
  fontFamily: "var(--font-roboto)",
  fontWeight: 400,
  marginBottom: "1.875rem",
  textAlign: "center",
};

export const form = {
  width: "100%",
  maxWidth: {
    sm: "450px",
  },
  marginTop: "1.87rem",
  margin: {
    sm: "1.87rem auto 0",
  },
};

export const titleClass = {
  textAlign: "center",
  fontFamily: "var(--font-arsenal)",
  fontSize: "2.25rem",
  fontWeight: 400,
  fontStyle: "normal",
};

export const subtitleClass = {
  textAlign: "center",
  fontFamily: "var(--font-roboto)",
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: 400,
  marginTop: "1.25rem",
};

export const ctaClass = {
  padding: { xs: "1.5625rem 1.25rem" },
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: { xs: "sticky", sm: "static" },
  bottom: 0,
  left: 0,
  right: 0,
  margin: { xs: "0 -1.25rem", sm: 0 },
};

export const ctaBtnClass = {
  width: "100%",
  marginTop: 0,
  fontVariant: "all-small-caps",
  fontSize: "0.875rem",
  fontFamily: "var(--font-roboto)",
  fontWeight: 600,
};
